export const SubmissionStateTypeTextEnum = {
    NotStarted: "NotStarted",
    Started: "Started",
    Submitted: "Submitted",
    Rejected: "Rejected",
    Resubmitted: "Resubmitted",
    Scored: "Scored",
    Completed: "Completed",
    Pending: "Pending"
}
